<template>
  <div class="fiduciary-connect-modal">
    <mds-modal
      class="series-selected-funds__modal"
      width="600px"
      v-model="appeared"
      :title="settings.title"
      :title-hidden="!settings.title"
      @mds-modal-dismissed="closeModal"
    >
      <component :is="settings.component" :data="settings.data" />
    </mds-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import MdsModal from '@mds/modal';

export default {
  components: {
    MdsModal,
  },
  data() {
    return {
      appeared: false,
    };
  },
  created() {
    this.appeared = this.show;
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
  },
  computed: {
    ...mapState({
      show: (state) => state.modal.show,
      settings: (state) => state.modal.settings,
    }),
  },
  watch: {
    show(newStatus) {
      this.appeared = newStatus;
    },
  },
};
</script>
<style lang="scss" module>
.mds-modal {
  &__title {
    @include mds-level-5-heading();
    font-weight: $mds-font-weight-bold;
    margin: 0;
  }
}

:global(.fiduciary-connect-modal) {
  .mds-modal {
    .mds-modal__wrapper {
      z-index: 810;
      position: relative;
    }
    .mds-modal__container {
      z-index: 810;
    }
    .mds-overlay {
      z-index: 800;
    }
  }
}
</style>
